import $ from "jquery";

/**
 * @constructor
 */
class HTTPSender {
  static URL = "https://ev.tremol.bg/OCPP/API2/";
  static URL_OLD = "https://ev.tremol.bg/OCPP/API/";

  // static URL = "https://router.tremol.bg:38091/API2/"; //TEST
  // static URL_OLD = "https://router.tremol.bg:38091/API/"; //TEST
  // static URL2 = "https://ev.tremol.bg/OCPP/API/"

  // static URL = "https://router.tremol.bg:48090/API/";
  // static URL = "http://router.tremol.bg:38081/API/"; //TEST

  static SETUP_DONE = false;
  static BEARER = null;
  static REQUESTS = [];

  static SetBearer(bearer) {
    if (bearer && (HTTPSender.BEARER == null || HTTPSender.BEARER != bearer)) {
      HTTPSender.BEARER = "Bearer " + bearer;
    }
  }

  static AbortAll = function () {
    HTTPSender.REQUESTS.forEach((r) => r.abort());
    HTTPSender.BEARER = null;
  };

  static SendR_API2 = function (verb, dataToSend, prefix, queryParams) {
    return HTTPSender.SendR(verb, dataToSend, prefix, queryParams, true);
  };

  static SendR = function (verb, dataToSend, prefix, queryParams, api_old) {
    //console.info("HTTP: " + prefix);
    //console.info(dataToSend)
    var queryString = "";
    if (queryParams) {
      if (queryParams instanceof Function) {
        queryParams = queryParams();
      }
      queryString = "?" + $.param(queryParams);
    }
    var dataO = {
      //timeout: 3000,
      type: verb,
      // dataType: "json",
      contentType: "json",
      async: true,
      url: (api_old ? HTTPSender.URL_OLD : HTTPSender.URL) + prefix + queryString,
      crossDomain: true,
      //xhrFields: { withCredentials: true },
      //processData: false,
      beforeSend: function (/** @type {JQueryXHR} */ xhr) {
        if (HTTPSender.BEARER) {
          xhr.setRequestHeader("Authorization", HTTPSender.BEARER);
        }
        xhr.setRequestHeader("Accept", "application/json");
        // xhr.setRequestHeader("Access-Control-Request-Headers", "access-control-allow-origin, allow-control-allow-credentials, Origin, X-Requested-With, Content-Type, Accept")
        // xhr.setRequestHeader("Access-Control-Allow-Origin", HTTPSender.URL);
        // xhr.setRequestHeader("Allow", "OPTIONS, GET, POST, HEAD");
        xhr.setRequestHeader("Access-Control-Allow-Origin", "http://localhost:44080");
        //xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        //xhr.setRequestHeader('Content-Type', contentType);
        xhr.setRequestHeader("Content-Type", "application/json");
        //xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        HTTPSender.REQUESTS.push(xhr);
      },
      complete: function (xhr) {
        HTTPSender.REQUESTS.splice(HTTPSender.REQUESTS.indexOf(xhr), 1);
        //console.info(JSON.stringify(xhr.responseJSON));
      },
    };
    //dataO.contentType = "json";
    // if (responseType) {
    //   dataO.xhr = function () {
    //     var xhr = new XMLHttpRequest();
    //     xhr.responseType = responseType;
    //     return xhr;
    //   };
    // }
    dataO.data = dataToSend;
    return $.ajax(dataO);
  };

  static SendMultiplePostR = function (arrayOfDataToSend, prefix, queryParams, done, fail) {
    $.when(...arrayOfDataToSend.map((d) => HTTPSender.SendPOSTreq(JSON.stringify(d), prefix, queryParams))).then(done, fail);
  };
  
  // static SendPOSTreq = function(dataToSend, urlserver, prefix, contentType) {
  //     return HTTPSender.SendR(true, dataToSend, urlserver, prefix, contentType, null);
  //}

  static SendPOSTreq = function (dataToSend, prefix, queryParams) {
    return HTTPSender.SendR("POST", dataToSend, prefix, queryParams);
  };

  // static SendGETreq = function(urlserver, prefix, responseType) {
  //     return HTTPSender.SendR(false, null, urlserver, prefix, responseType,  null);
  // }

  static SendGETreq = function (prefix, queryParams) {
    return HTTPSender.SendR("GET", null, prefix, queryParams);
  };

  static SendGETreq_API_OLD = function (prefix, queryParams) {
    return HTTPSender.SendR("GET", null, prefix, queryParams, true);
  };
}

if (!HTTPSender.SETUP_DONE) {
  $.ajaxSetup({
    statusCode: {
      401: function () {
        location.href = "./login?error=Необходимо е да влезете в системата!";
      },
    },
  });
  HTTPSender.SETUP_DONE = true;
}

export default HTTPSender;
